import $ from 'jquery'
if (typeof window !== 'undefined') {
    window.$ = $
    window.jQuery = $
}

export default $